// extracted by mini-css-extract-plugin
module.exports = {"container":"error__container___1sQgh","error":"error__error___2ewmy"};